const CUSTOM_ERROR_MESSAGES = {
  DUPLICATE_EMAIL: 'Email has already been taken',
  NO_PRIMARY_APPLICANT: 'Please select only one primary applicant',
  MORE_THAN_ONE_PRIMARY_APPLICANT: 'Only one primary applicant should be selected',
}

export { CUSTOM_ERROR_MESSAGES }
